import {
  require_identity
} from "./chunk-IVDMN2QC.js";
import {
  __commonJS
} from "./chunk-TFWDKVI3.js";

// ../../shared/node_modules/lodash/_baseSum.js
var require_baseSum = __commonJS({
  "../../shared/node_modules/lodash/_baseSum.js"(exports, module) {
    function baseSum(array, iteratee) {
      var result, index = -1, length = array.length;
      while (++index < length) {
        var current = iteratee(array[index]);
        if (current !== void 0) {
          result = result === void 0 ? current : result + current;
        }
      }
      return result;
    }
    module.exports = baseSum;
  }
});

// ../../shared/node_modules/lodash/sum.js
var require_sum = __commonJS({
  "../../shared/node_modules/lodash/sum.js"(exports, module) {
    var baseSum = require_baseSum();
    var identity = require_identity();
    function sum(array) {
      return array && array.length ? baseSum(array, identity) : 0;
    }
    module.exports = sum;
  }
});
export default require_sum();
//# sourceMappingURL=lodash_sum.js.map
